import { render, staticRenderFns } from "./RequestIndividualAccountForDataAdministrator.vue?vue&type=template&id=0f6b890a&scoped=true"
import script from "./RequestIndividualAccountForDataAdministrator.vue?vue&type=script&lang=js"
export * from "./RequestIndividualAccountForDataAdministrator.vue?vue&type=script&lang=js"
import style0 from "./RequestIndividualAccountForDataAdministrator.vue?vue&type=style&index=0&id=0f6b890a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b890a",
  null
  
)

export default component.exports